import React, { Component } from "react";
import Layout from "./app/Layout";
import "./App.css";

// App.js
class App extends Component {
  render() {
    return <Layout />;
  }
}

export default App;
